import React from 'react'
import { useParams } from 'react-router-dom'

import Session from './components/Session/Session.container'
import Tag from './components/Tag/Tag.container'
import Handoff from './components/Handoff/Handoff.container'
import Users from './components/Users/Users.container'
import Interactions from './components/Interactions/Interactions.container'
import Inbound from './components/Messages/Inbound.container'
import Outbound from './components/Messages/Outbound.container'
import Sentiments from './components/Sentiments/Sentiments.container'
import Export from './components/Export/Export.container'
import Events from './components/Events/Events.container'
import ResolvedByBot from './components/ResolvedByBot/ResolvedByBot.container'

import NotFoundPage from 'shared/components/common/NotFoundPage/NotFoundPage.component'

const Sections = () => {
  const { section } = useParams()
  switch (section) {
    case 'sessions': return <Session />
    case 'handover': return <Handoff />
    case 'tags': return <Tag />
    case 'resolved-by-bot': return <ResolvedByBot />
    case 'interactions': return <Interactions />
    case 'events': return <Events />
    case 'inbound': return <Inbound />
    case 'outbound': return <Outbound />
    case 'users': return <Users />
    case 'sentiments': return <Sentiments />
    case 'report': return <Export />

    default: return <NotFoundPage />
  }
}

Sections.propTypes = {}

export default Sections
